import { Link } from 'react-router-dom';
import { Sparkles, ArrowRight } from 'lucide-react';

// Inline CTA Button - for placing within content
export const FreeTrialButton = ({ className = "", size = "default" }) => {
  const sizeClasses = {
    small: "px-4 py-2 text-sm",
    default: "px-6 py-3 text-base",
    large: "px-8 py-4 text-lg"
  };

  return (
    <Link 
      to="/free-trial"
      className={`inline-flex items-center gap-2 bg-[#00D4FF] hover:bg-[#00B8E6] text-black font-bold uppercase tracking-wide rounded-lg transition-all hover:scale-105 shadow-lg shadow-[#00D4FF]/30 ${sizeClasses[size]} ${className}`}
      data-testid="free-trial-cta"
    >
      <Sparkles className="w-5 h-5" />
      Book Your Free Trial
      <ArrowRight className="w-4 h-4" />
    </Link>
  );
};

// Banner CTA - full width promotional banner
export const FreeTrialBanner = ({ variant = "default" }) => {
  const variants = {
    default: "bg-gradient-to-r from-[#00D4FF] to-[#00B8E6]",
    dark: "bg-[#00D4FF]/10 border border-[#00D4FF]/30",
    vibrant: "bg-gradient-to-r from-[#00D4FF] via-[#7000FF] to-[#FF007F]"
  };

  return (
    <div className={`${variants[variant]} py-6 px-4`} data-testid="free-trial-banner">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
        <div>
          <h3 className={`text-xl font-bold uppercase ${variant === 'dark' ? 'text-white' : 'text-black'}`}>
            Not sure where to start?
          </h3>
          <p className={`${variant === 'dark' ? 'text-white/70' : 'text-black/70'}`}>
            Try a class for FREE - no obligation, just fun!
          </p>
        </div>
        <Link 
          to="/free-trial"
          className={`inline-flex items-center gap-2 ${variant === 'dark' ? 'bg-[#00D4FF] text-black' : 'bg-black text-white'} px-6 py-3 font-bold uppercase tracking-wide rounded-lg transition-all hover:scale-105`}
        >
          <Sparkles className="w-5 h-5" />
          Book Free Trial
        </Link>
      </div>
    </div>
  );
};

// Floating CTA - fixed position button
export const FreeTrialFloating = () => {
  return (
    <Link 
      to="/free-trial"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#00D4FF] hover:bg-[#00B8E6] text-black px-5 py-3 font-bold uppercase tracking-wide rounded-full shadow-2xl shadow-[#00D4FF]/40 transition-all hover:scale-110 animate-bounce hover:animate-none"
      data-testid="free-trial-floating"
    >
      <Sparkles className="w-5 h-5" />
      <span className="hidden sm:inline">Free Trial</span>
    </Link>
  );
};

// Card CTA - for sidebars or feature sections
export const FreeTrialCard = () => {
  return (
    <div className="bg-gradient-to-br from-[#00D4FF]/20 to-[#00D4FF]/5 border border-[#00D4FF]/30 rounded-xl p-6 text-center" data-testid="free-trial-card">
      <div className="w-16 h-16 bg-[#00D4FF]/20 rounded-full flex items-center justify-center mx-auto mb-4">
        <Sparkles className="w-8 h-8 text-[#00D4FF]" />
      </div>
      <h3 className="text-xl font-bold text-white mb-2">Try Before You Commit!</h3>
      <p className="text-white/60 mb-4 text-sm">
        Experience a class for free and see why our students love UPA
      </p>
      <Link 
        to="/free-trial"
        className="inline-flex items-center justify-center gap-2 w-full bg-[#00D4FF] hover:bg-[#00B8E6] text-black px-6 py-3 font-bold uppercase tracking-wide rounded-lg transition-all hover:scale-105"
      >
        Book Free Trial
        <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
};

export default FreeTrialButton;
